import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Helmet } from "react-helmet-async";
export const AppSEO = memo(({ title, description, children }) => {
    return (_jsxs(Helmet, { children: [_jsx("title", { children: `${title !== null && title !== void 0 ? title : "⎄"} | Highlight` }), _jsx("meta", { name: "author", content: "Highlight" }), description && (_jsx("meta", { name: "description", content: description.substring(0, 250) })), children] }));
});
